import { RegistryObject } from "@mcleod/core";
import { ModelDataChangeFilterData } from "./ModelDataChangeFilterData";
import { ModelDataChangeSingleFilterResult } from "./ModelDataChangeFilterResult";

export abstract class ModelDataChangeFilter extends RegistryObject {
    abstract evaluate(data: ModelDataChangeFilterData): ModelDataChangeSingleFilterResult;
}
